export default "__VITE_ASSET__EwX$2KR5__"